











import { createComponent, computed } from "@vue/composition-api";
import { Tag } from "element-ui";

interface Props {
  size: "small" | "medium" | "large";
  variant: "success" | "warning" | "danger" | "info" | undefined;
}

const elSizeMap = {
  large: "medium",
  medium: "small",
  small: "mini",
};

export default createComponent<Props>({
  components: { Tag },
  props: {
    size: { default: "medium" },
    variant: {},
  },
  setup(props, ctx) {
    const elSize = computed(() => elSizeMap[props.size]);
    return { elSize };
  },
});
